<template>
  <div>
    <v-container class="mb-4">
      <v-row>
        <v-col cols="12">
          <v-icon class="pr-2">mdi-calendar</v-icon>
          Proposta válida até {{ resposta.validade | date }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-icon class="pr-2">mdi-truck</v-icon>
          Frete {{ resposta.frete.tipoFrete }}
          ({{ resposta.frete.prazoEntrega | pluralize(['dia útil', 'dias úteis'])}})
        </v-col>
      </v-row>
      <px-cotacao-conjunta-resposta-finalizacao-table :resposta="resposta" />
    </v-container>
    <v-btn color="primary"
           class="mr-2"
           :loading="loading"
           @click="clickNext">
      Enviar
    </v-btn>
    <v-btn @click="clickPrevious">
      Voltar
    </v-btn>
  </div>
</template>

<script>
import CotacaoConjuntaRespostaFinalizacaoTable from './CotacaoConjuntaRespostaFinalizacaoTable.vue';

export default {
  props: {
    loading: Boolean,
    resposta: Object,
  },
  methods: {
    clickNext() {
      this.$emit('next');
    },
    clickPrevious() {
      this.$emit('previous');
    },
  },
  components: {
    pxCotacaoConjuntaRespostaFinalizacaoTable: CotacaoConjuntaRespostaFinalizacaoTable,
  },
};
</script>
